var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',[_c('div',{staticClass:"wrapper",style:(`width: calc(100vw - ${_vm.sideNavWidth}px)`)},[_c('client',{attrs:{"id":_vm.$route.params.ruleId,"title":_vm.title,"isTemplate":""}})],1)]),_c('unsavedChangesModal',{attrs:{"value":_vm.showLeaveConfirmation},on:{"closeModal":_vm.cancelConfirmation,"confirmLeave":_vm.leave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }